module.exports = __webpack_public_path__ + "img/Globe.cefdcfa4.png";